import { useEffect, useState } from 'react';
import { Star, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ASSETS } from '../constants/site';
import { api } from '../App';

export default function Review() {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    api.get('/settings/review').then((r) => setUrl(r.data.url || '')).catch(() => setUrl(''));
  }, []);

  return (
    <div className="min-h-screen bg-[#050B14] circuit-bg flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="gold-ring rounded-3xl bg-[#0F1C33]/80 p-10 max-w-md w-full text-center"
        data-testid="review-page"
      >
        <img src={ASSETS.icon} alt="GSLAB" className="h-16 w-16 rounded-xl mx-auto mb-6" />
        <div className="flex justify-center gap-1 mb-5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={22} className="text-amber-400 fill-amber-400" />
          ))}
        </div>
        <h1 className="font-display font-bold text-2xl mb-3">Enjoying your GSLAB build?</h1>
        <p className="text-sm text-slate-400 mb-8 leading-relaxed">
          A 30-second Google review helps other small businesses find an engineer they can trust — and means the world to us.
        </p>
        {url === null ? (
          <Loader2 size={20} className="text-amber-400 animate-spin mx-auto" />
        ) : url ? (
          <a
            data-testid="google-review-button"
            href={url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 w-full bg-gradient-to-r from-[#D4AF37] via-[#F3C64F] to-[#D4AF37] text-[#050B14] font-bold rounded-full px-6 py-3.5 hover:shadow-[0_0_28px_rgba(212,175,55,0.4)] transition-shadow duration-300"
          >
            <Star size={17} /> Leave a Google review
          </a>
        ) : (
          <p data-testid="review-coming-soon" className="text-sm text-amber-300/80 border border-amber-500/25 bg-amber-500/5 rounded-xl px-5 py-4">
            Our Google Business Profile goes live shortly — check back soon, or email your kind words to{' '}
            <a href="mailto:jhk505@gatech.edu" className="underline">jhk505@gatech.edu</a>.
          </p>
        )}
        <Link to="/" className="inline-block mt-6 text-xs text-slate-500 hover:text-amber-300 transition-colors">
          ← Back to gslab.engineer
        </Link>
      </motion.div>
    </div>
  );
}
